import { render, staticRenderFns } from "./index4.vue?vue&type=template&id=51ab48ec"
import script from "./index4.vue?vue&type=script&lang=js"
export * from "./index4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports